import { Outlet } from 'react-router'

export function RootLayout() {
  return (
    <div
      className="min-h-screen-updated bg-gradient-to-b from-zinc-900 to-zinc-950 font-sans"
      style={{
        paddingTop: 'env(safe-area-inset-top)',
        paddingBottom: 'env(safe-area-inset-bottom)',
        paddingLeft: 'env(safe-area-inset-left)',
        paddingRight: 'env(safe-area-inset-right)',
      }}
    >
      <Outlet />
    </div>
  )
}
